export const SERVICES_FAQS = [
  {
    question: "How much does a new fence cost in Perth?",
    answer:
      "Colorbond starts around $95 per lineal metre supplied and installed, aluminium slat from $185, pool fencing from $110 and retaining walls from $290 per m². Height, access and site prep move the number — your written quote is fixed.",
  },
  {
    question: "Who pays for a dividing fence in WA?",
    answer:
      "Under the Dividing Fences Act, neighbours who share a boundary usually split a standard dividing fence 50/50. We prepare the paperwork so both sides can sign off before work starts.",
  },
  {
    question: "How long does the whole process take?",
    answer:
      "Most jobs are measured, quoted and installed within two weeks of your first call, with the physical install itself usually done in 1-3 days depending on the job.",
  },
  {
    question: "Do I need council approval for my fence?",
    answer:
      "Most standard dividing fences don't need a permit, but pool barriers, retaining walls over 500mm and some front fences do. We check this for you as part of the free measure.",
  },
  {
    question: "Can you remove the old fence — even asbestos?",
    answer:
      "Yes — our crews are licensed to remove and dispose of asbestos-cement fencing to WorkSafe WA standards, and we can install your new fence in the same visit.",
  },
  {
    question: "Which areas do you service?",
    answer: "Perth metro, Joondalup, Wanneroo, Rockingham, Mandurah, Bunbury and the South West.",
  },
  {
    question: "What warranty comes with the work?",
    answer:
      "Every job carries a workmanship warranty on top of the manufacturer's product warranty — typically 10 years on Colorbond, aluminium and powder-coated steel.",
  },
  {
    question: "Can I get a price without a site visit?",
    answer:
      "Our calculators give you a solid estimate instantly, but every job is confirmed with a free on-site measure before you commit to a fixed written quote.",
  },
];
